// Shared by `useUserPermissionStates` and `useHasAccessToFeature`: their
// submit-as team-members requests must use the same query string so they
// dedupe onto one SWR cache entry.
export const AGENT_TEAM_MEMBER_FILTER =
  'status[in]=[ACTIVE,ONBOARDING,OFFBOARDING]&roles[eq]=AGENT';
